module.exports = __webpack_public_path__ + "static/media/introsection.8f652d01.png";